import React from 'react'
import {connect} from 'react-redux'
import {storePayload} from '../actions/storePayload'
import {Button, Icon} from '@lazarusai/forms-ui-components'
import '../styles/Footer.css'

function FormFooter(props) {
  function ifChatCloseChat() {
    if (props.isChatShowing) {
      props.storePayload({
        isChatShowing: false,
      })
    }
  }
  return (
    <footer
      className='footer form-footer'
      onClick={ifChatCloseChat}
      style={
        props.style ?
          {
            width: props.style.width || '100%',
            left: props.style.left || 0,
          } :
          {}
      }
    >
      <div
        className='footer-content'
        style={
          props.style?.padding ?
          {
            padding: props.style.padding,
          } :
          {}
        }
      >
        {props.onClickBtn1 ?
        <div
          className='btn1-container'
        >
          <Button
            style={{
              backdropFilter: 'initial',
            }}
            text={props.btn1Text}
            onClick={props.onClickBtn1}
            theme={props.theme}
          />
        </div> :
        <div className='btn1-container'></div>
        }
        {props.hideArrowBtns ?
          <div className='arrow-btns'></div> :
          <div className='arrow-btns'>
            <Button
              style={{
                backdropFilter: 'initial',
              }}
              text=''
              onClick={props.onClickArrowUp}
              width='2.5em'
              theme={props.theme}
              iconJustify='center'
              icon={
                <Icon
                  icon='arrow-ios-upward-outline'
                  key='back'
                />
              }
              className='arrow-btn'
              disabled={props.onClickArrowUp ? false : true}
            />
            <Button
              style={{
                backdropFilter: 'initial',
              }}
              text=''
              onClick={props.onClickArrowDown}
              width={'2.5em'}
              theme={props.theme}
              iconJustify='center'
              icon={
                <Icon
                  icon='arrow-ios-downward-outline'
                  key='next'
                />
              }
              className='arrow-btn'
              disabled={props.onClickArrowDown ? false : true}
            />
          </div>
        }
        <div className='right-container'>
          <Button
            style={{
              backdropFilter: 'initial',
            }}
            text={'Chat Assistance'}
            icon={
              <Icon
                icon='message-square-outline'
                key='okay'
              />
            }
            onClick={props.onClickChat}
            theme={props.theme}
            disabled={props.onClickChat ? false : true}
          />
        </div>
      </div>
    </footer>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  isChatShowing: state.userReducer.isChatShowing,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(FormFooter)

